import React, { useContext, useCallback } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';
import styled from 'styled-components';

import { CustomRow } from 'src/presentation/components/forms/CustomRow';
import { DAY_OF_WEEK } from 'src/presentation/components/pages/shared/TimeConstants';
import FormContext from 'src/presentation/contexts/FormContext';
import { InputSize } from 'src/presentation/components/forms/InputSize';
import { Section } from 'src/presentation/components/forms/Layout';
import TimeRange from './TimeRange';
import TimeZoneSelector from 'src/presentation/components/pages/shared/TimeZoneSelector';

const HoursTableSection = ({
  header,
  description,
  showTimezone = true,
  timezonePath,
  dayPath,
  timeRangeHeaderLabel = '',
}) => {
  const { workingState, updateState } = useContext(FormContext);

  const onTimeRangeChanged = useCallback(
    ({ attr, value }) => {
      updateState(set({}, attr, value), { replaceArrayValues: true });
    },
    [updateState]
  );

  const timeRangeHeader = () => {
    if (timeRangeHeaderLabel) {
      return (
        <TimeRangesRowsHeader>
          <StyledLabel>{timeRangeHeaderLabel}</StyledLabel>
        </TimeRangesRowsHeader>
      );
    }
    return null;
  };

  return (
    <Section id="hours-table" header={header} description={description}>
      {showTimezone ? <TimeZoneSelector attr={timezonePath} label="Timezone" /> : null}
      {timeRangeHeader()}
      <HalfRow>
        <TimeRangesRows>
          {DAY_OF_WEEK.map(day => {
            const dayDataPath = `${dayPath}.${day}`;
            const dayData = get(workingState, dayDataPath, []);
            return (
              <TimeRange
                attr={dayDataPath}
                dayData={dayData}
                key={`${dayDataPath}.timeRange`}
                label={day}
                onTimeRangeChanged={onTimeRangeChanged}
              />
            );
          })}
        </TimeRangesRows>
      </HalfRow>
    </Section>
  );
};

const TimeRangesRows = styled.div`
  margin-bottom: 0;
  width: 100%;
`;

const TimeRangesRowsHeader = styled(TimeRangesRows)`
  margin-bottom: 15px;
`;

const StyledLabel = styled.label`
  align-self: flex-start;
  font-size: 13px;
  font-weight: bolder;
  margin-bottom: 8px;
  min-height: 18px;
`;

const HalfRow = styled(CustomRow)`
  width: 50%;
  max-width: 470px;
  min-width: 350px;
`;

export const DropdownContainer = styled.div`
  width: ${InputSize.LARGE}px;
`;

export default HoursTableSection;
